/**
 * buildFile
 * 
 * Создаёт файл с указанным контентом и MIME-типом и инициирует начало его сачивания
 * 
 * !!! НЕ ИСПОЛЬЗОВАТЬ ДЛЯ БОЛЬШИХ ОБЪЁМОВ ДАННЫХ !!!
 * 
 * @param {*} content   - содержимое файла
 * @param {String} mime - MIME-тип создаваемого файла 
 * @param {String} name - имя файла
 */
export default function buildFile(content, mime, name) {

    let downloadLink            = document.createElement("a")
        downloadLink.href       = URL.createObjectURL(new Blob([content], {type: mime}))
        downloadLink.download   = name
        downloadLink.click()
}